import { render, staticRenderFns } from "./pesquisar-servicos-preco.vue?vue&type=template&id=2b18ede2&scoped=true&"
import script from "./pesquisar-servicos-preco.vue?vue&type=script&lang=js&"
export * from "./pesquisar-servicos-preco.vue?vue&type=script&lang=js&"
import style0 from "./pesquisar-servicos-preco.vue?vue&type=style&index=0&id=2b18ede2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18ede2",
  null
  
)

export default component.exports